import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cc239a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { Ref, ref } from 'vue';
import { useAuth } from '@/store/useAuth';
import { onMounted } from 'vue';
import ActivityService from '@/services/ActivityService';
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerTop',
  setup(__props) {

const loading = ref(true)
const store = useAuth()
const isHidden: Ref<boolean> = ref(true);
const service = new ActivityService()
const activity = ref(false)

onMounted(async () => {
    if (store.token === null) {
        return;
    }
    loading.value = true
    try {
        activity.value = await service.deleteBanner(store.token)
    }
    catch (error) {
        console.error("Error al eliminar el banner:", error);
    }
    finally {
        loading.value = false
    }
});

async function hideParent(forever: boolean) {
    if (store.token === null) {
        return;
    }
    isHidden.value = false;
    if (forever) {
        await service.hiddenBanner(store.token)
    }

}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (activity.value)
    ? (_openBlock(), _createBlock(_Transition, {
        key: 0,
        name: "slide-up",
        style: {"margin-top":"25px"}
      }, {
        default: _withCtx(() => [
          (isHidden.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(main).TITTLE), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(main).TEXT_SOCIAL), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (_unref(main).HAS_FACEBOOK)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _unref(main).LINK_FACEBOOK,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "bi-facebook",
                          class: "icon"
                        })
                      ], 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_TWITTER)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _unref(main).LINK_TWITTER,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "io-logo-twitter",
                          class: "icon"
                        })
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_LINKEDIN)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: _unref(main).LINK_LINKEDIN,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "bi-linkedin",
                          class: "icon"
                        })
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_INSTAGRAM)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: _unref(main).LINK_INSTAGRAM,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "co-instagram",
                          class: "icon"
                        })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_YOUTUBE)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        href: _unref(main).LINK_YOUTUBE,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "io-logo-youtube",
                          class: "icon"
                        })
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_TIKTOK)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 5,
                        href: _unref(main).LINK_TIKTOK,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "co-tiktok",
                          class: "icon"
                        })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_unref(main).HAS_X)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 6,
                        href: _unref(main).LINK_X,
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "bi-x-s-quare",
                          class: "icon"
                        })
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (hideParent(false)))
                  }, "Cerrar"),
                  _hoisted_12,
                  (_unref(store).token)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (hideParent(true))),
                        class: "btn-ok"
                      }, "¡Hecho! No mostrar más"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})